// extracted by mini-css-extract-plugin
export var changeIcon = "_4v-4";
export var clickable = "_4v-8";
export var container = "_4v-0";
export var divider = "_4v-7";
export var externalLinkIcon = "_4v-1";
export var green = "_4v-5";
export var helpCircleIcon = "_4v-3";
export var iconButton = "_4v-2";
export var red = "_4v-6";